import React, { Component } from "react";

import { authenticationService } from '../services';

class SFDCCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      migrated: false
    };
  }

  componentDidMount() {
    const code = new URLSearchParams(window.location.search).get("code");
    const state = new URLSearchParams(window.location.search).get("state");
    console.log(code);
    console.log(state);
    if (state === 'Stripe') {
      authenticationService.generateSfdcToken(code, () => {
        //window.location = 'https://portal.xencallpay.com';
      });  
    }
    if (state === 'Maxio') {
      authenticationService.generateMaxioSfdcToken(code, () => {
        //window.location = 'https://portal.xencallpay.com';
        window.location = 'https://bc880ca5a1ba.ngrok.app';
      });        
    }
  }

  render() {
    console.log("Processing Authentication Code", this.props);

    return (
      <div style={{ padding: 16, margin: "auto" }}>
        Processing Authentication Code
      </div>
    );
  }
}

export { SFDCCallback };
